(function(){
  'use strict';

  // Intercept clicks on add-to-cart buttons inside complementary product cards
  document.addEventListener('click', function(e){
    // We run in capture by default? Fallback: attach another capturing listener below
  }, true);

  document.addEventListener('click', onCardAddClick, true);
  document.addEventListener('change', onVariantChange, true);

  function onCardAddClick(e){
    try{
      var btn = e.target && (e.target.closest && e.target.closest('add-to-cart'));
      if(!btn) return;

      // Only take over inside complementary sections
      var compRoot = btn.closest && btn.closest('.complementary-products');
      if(!compRoot) return;

      // Prevent theme's default add-to-cart (no drawer)
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      var variantId = btn.dataset && btn.dataset.variantId;
      if(!variantId){
        // Try reading a select near the button if dataset is missing
        var select = btn.closest('.card-information').querySelector('select[name="id"], .card-variant-picker select');
        if(select && select.value){ variantId = select.value; }
      }
      if(!variantId) return;

      var properties = getLineItemProperties(btn);
      var payload = { id: variantId, quantity: 1 };
      if (Object.keys(properties).length > 0) {
        payload.properties = properties;
      }

      btn.disabled = true;
      btn.classList.add('iu-add');
      btn.classList.add('loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
      .then(function(r){ if(!r.ok) throw new Error('Failed to add'); return r.json(); })
      .then(function(){ return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }); })
      .then(function(r){ return r.json(); })
      .then(function(cartData){
        updateCartCountBubbles(cartData.item_count);
        updateMiniCartSilently(cartData);
        publishCartUpdate(cartData);
        showSuccessAnimation(btn);
        flyToCart(btn.closest('.card-wrapper'));
      })
      .catch(function(err){
        console.error('Card add error:', err);
      })
      .finally(function(){
        // reset loading if success handler doesn't already
        setTimeout(function(){ btn.classList.remove('loading'); btn.disabled = false; }, 2000);
      });
    }catch(err){
      console.error(err);
    }
  }

  function onVariantChange(e){
    try{
      var select = e.target;
      if(!select || select.tagName !== 'SELECT') return;
      var compRoot = select.closest && select.closest('.complementary-products');
      if(!compRoot) return;
      var wrapper = select.closest('.card-wrapper');
      if(!wrapper) return;
      var variantId = select.value;
      // update add-to-cart binding if present
      var btn = wrapper.querySelector('add-to-cart');
      if(btn){ btn.dataset.variantId = variantId; }
      // update all anchors to open with chosen variant
      var anchors = wrapper.querySelectorAll('a.card__media, a.media-wrapper, a.card-information__text, .card-information > a.full-unstyled-link');
      anchors.forEach(function(a){ a.href = setVariantParam(a.href, variantId); });
    }catch(err){
      console.error(err);
    }
  }

  function setVariantParam(href, variantId){
    try{
      var u = new URL(href, window.location.origin);
      u.searchParams.set('variant', String(variantId));
      return u.toString();
    }catch(e){
      // Fallback: naive replace/append
      if(/([?&])variant=\d+/.test(href)) return href.replace(/([?&])variant=\d+/, '$1variant=' + String(variantId));
      return href + (href.indexOf('?') === -1 ? '?' : '&') + 'variant=' + String(variantId);
    }
  }

  function getLineItemProperties(addToCartEl){
    var properties = {};
    if(!addToCartEl || !addToCartEl.querySelectorAll) return properties;

    var fields = addToCartEl.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]');
    fields.forEach(function(field){
      if(!field || field.disabled) return;
      var name = field.getAttribute('name') || '';
      var match = name.match(/^properties\[(.*)\]$/);
      if(!match || !match[1]) return;
      if((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
      properties[match[1]] = field.value;
    });

    return properties;
  }

  function updateCartCountBubbles(count){
    try{
      function ensureBubble(container, c){
        if(!container) return;
        var bubble = container.querySelector('.cart-count-bubble');
        if(!bubble && c > 0){
          bubble = document.createElement('span');
          bubble.className = 'cart-count-bubble' + (c >= 100 ? ' cart-count-bubble--dot' : '');
          if(c < 100){
            var inner = document.createElement('span');
            inner.setAttribute('aria-hidden','true');
            inner.textContent = String(c);
            bubble.appendChild(inner);
          }
          var hidden = document.createElement('span');
          hidden.className = 'visually-hidden';
          hidden.textContent = 'Cart count ' + String(c);
          bubble.appendChild(hidden);
          container.appendChild(bubble);
        } else if(bubble){
          if(c > 0){
            bubble.classList.toggle('cart-count-bubble--dot', c >= 100);
            var num = bubble.querySelector('span[aria-hidden="true"]');
            if(num){
              if(c < 100){ num.textContent = String(c); }
              else { num.textContent = ''; }
            } else if(c < 100){
              var n = document.createElement('span');
              n.setAttribute('aria-hidden','true');
              n.textContent = String(c);
              bubble.insertBefore(n, bubble.firstChild);
            }
            bubble.style.display = '';
          } else {
            bubble.remove();
          }
        }
      }
      var bubbles = document.querySelectorAll('.cart-count-bubble');
      bubbles.forEach(function(b){ if(count > 0){ b.style.display=''; b.classList.toggle('cart-count-bubble--dot', count >= 100); var s=b.querySelector('span[aria-hidden="true"]'); if(s && count < 100){ s.textContent = count; } } });
      ensureBubble(document.getElementById('cart-icon-bubble'), count);
      ensureBubble(document.getElementById('mobile-cart-icon-bubble'), count);
    }catch(e){}
  }

  function updateMiniCartSilently(cartData){
    try{
      var miniCart = document.querySelector('mini-cart');
      if(!miniCart) return;
      if(typeof miniCart.renderContentsSilently === 'function'){
        var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url) ? window.theme.routes.cart_url : '/cart';
        var sections = miniCart.getSectionsToRender ? miniCart.getSectionsToRender() : [];
        if(sections.length > 0){
          var ids = sections.map(function(s){ return s.id || s.section; }).join(',');
          fetch(cartUrl + '?sections=' + encodeURIComponent(ids), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function(r){ return r.json(); })
            .then(function(sectionsData){ miniCart.renderContentsSilently(Object.assign({}, cartData, { sections: sectionsData })); })
            .catch(function(){ /* no drawer open fallback */ });
        }
      }
    }catch(e){}
  }

  function publishCartUpdate(cartData){
    try{
      if(typeof document.dispatchEvent === 'function'){
        var event;
        if(typeof CustomEvent === 'function'){
          event = new CustomEvent('ajaxProduct:added', { detail: { product: cartData } });
        } else {
          event = document.createEvent('CustomEvent');
          event.initCustomEvent('ajaxProduct:added', true, true, { product: cartData });
        }
        document.dispatchEvent(event);
      }
    }catch(e){}
    try{ if(typeof publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate){ publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'card-direct-add', cartData: cartData }); } }catch(e){}
  }

  function showSuccessAnimation(btn){
    try{
      btn.classList.remove('loading');
      btn.classList.add('success');
      if(btn._resetTimeout){ clearTimeout(btn._resetTimeout); }
      btn._resetTimeout = setTimeout(function(){ btn.classList.remove('success'); btn.disabled = false; btn._resetTimeout = null; }, 2000);
    }catch(e){}
  }

  function flyToCart(cardRoot){
    try{
      if(!cardRoot) return;
      var img = cardRoot.querySelector('.card__media img, .media img, img');
      if(!img) return;
      var target = pickCartTarget();
      if(!target) return;
      if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches){ bumpTarget(target); return; }
      var imgRect = img.getBoundingClientRect();
      var targetRect = target.getBoundingClientRect();
      var clone = img.cloneNode(true);
      clone.className = (clone.className ? clone.className + ' ' : '') + 'iu-fly-clone';
      clone.style.left = imgRect.left + 'px';
      clone.style.top = imgRect.top + 'px';
      clone.style.width = imgRect.width + 'px';
      clone.style.height = imgRect.height + 'px';
      clone.style.opacity = '0.9';
      clone.style.transform = 'translate3d(0,0,0)';
      document.body.appendChild(clone);
      clone.offsetHeight; // force reflow
      var deltaX = (targetRect.left + (targetRect.width / 2)) - (imgRect.left + (imgRect.width / 2));
      var deltaY = (targetRect.top + (targetRect.height / 2)) - (imgRect.top + (imgRect.height / 2));
      clone.style.transform = 'translate(' + deltaX + 'px,' + deltaY + 'px) scale(0.3)';
      clone.style.opacity = '0.2';
      var cleanedUp = false;
      function cleanup(){ if(cleanedUp) return; cleanedUp = true; if(clone && clone.parentNode){ clone.parentNode.removeChild(clone); } bumpTarget(target); }
      clone.addEventListener('transitionend', cleanup, { once: true });
      setTimeout(cleanup, 700);
    }catch(e){}
  }

  function bumpTarget(target){
    try{
      if(!target) return;
      var el = target.querySelector ? (target.querySelector('.cart-count-bubble') || target) : target;
      el.classList.add('cart-bump');
      setTimeout(function(){ el.classList.remove('cart-bump'); }, 300);
    }catch(e){}
  }

  function pickCartTarget(){
    var candidates = [
      document.querySelector('#mobile-cart-icon-bubble .cart-count-bubble'),
      document.getElementById('mobile-cart-icon-bubble'),
      document.querySelector('#cart-icon-bubble .cart-count-bubble'),
      document.getElementById('cart-icon-bubble')
    ];
    for(var i=0;i<candidates.length;i++){ if(isVisible(candidates[i])) return candidates[i]; }
    var fallbacks = [
      document.querySelector('.cart-count-bubble'),
      document.querySelector('.icon-cart'),
      document.querySelector('[data-cart-toggle]'),
      document.querySelector('a[href*="/cart"]')
    ];
    for(i=0;i<fallbacks.length;i++){ if(isVisible(fallbacks[i])) return fallbacks[i]; }
    return null;
  }

  function isVisible(el){
    if(!el) return false;
    try{
      var rect = el.getBoundingClientRect();
      if(rect.width <= 1 && rect.height <= 1) return false;
      if(rect.bottom < 0 || rect.right < 0) return false;
      var vw = window.innerWidth || document.documentElement.clientWidth;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if(rect.top > vh || rect.left > vw) return false;
      var style = window.getComputedStyle(el);
      if(style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
      return true;
    }catch(e){ return false; }
  }
})();


